import { getTaxDetailsSummaryForPortfolio } from "../../config/apiConfig";
import {
   FETCH_TAXSUMMARY_BEGIN,
   FETCH_TAXSUMMARY_SUCCESS,
   FETCH_TAXSUMMARY_FAILURE
  } from '../constants/taxsummary';
import { sbaAxios } from "../utils/sbaAxios";


export const getTaxSummary=(FundID,taxYear,PortfolioID)=> {
   return (dispatch) => {
    dispatch(fetchTaxSummaryBegin());
    sbaAxios({url:`${getTaxDetailsSummaryForPortfolio}${FundID},${taxYear},${PortfolioID}`,method:'get'})
    .then((reponse) => {
      const taxSummary = reponse;
      dispatch(fetchTaxSummarySuccess(taxSummary));
      return taxSummary;
    })
    .catch((error) => dispatch(fetchTaxSummaryFailure(error)));
  };
}

export const fetchTaxSummaryBegin = () => ({
  type: FETCH_TAXSUMMARY_BEGIN,
});

export const fetchTaxSummarySuccess = (taxSummary) => ({
  type: FETCH_TAXSUMMARY_SUCCESS,
  payload: {taxSummary},
});


export const fetchTaxSummaryFailure = (errorMessage) => ({
  type: FETCH_TAXSUMMARY_FAILURE,
  payload: {errorMessage}
});

